(ns app.front.view.group.admin.default-work-type-target
  (:require [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(defn- get-current-value [changes {config-id :db/id :as config} attr entity?]
  (get-in changes [config-id attr] (-> config
                                       attr
                                       (cond->
                                         entity? :db/id))))


(defn- update-changes! [ptc-id {config-id :db/id :as config-in-db} new-changes]
  (>evt [::gas/update-ptc-group-config-changes
         ptc-id
         config-id
         #(reduce (fn [config-changes [k v]]
                    ; UI value restored to db value -> remove from changes
                    (if (= v (get config-in-db k))
                      (dissoc config-changes k)
                      (assoc config-changes k v)))
                  %
                  new-changes)]))


;; Valid values won't result in a default work type without target or a default work target without type
(rf/reg-sub ::valid-setting-changes?
  :<- [::entities/entity-db]
  (fn [entity-db [_ id->changes]]
    (every? (fn [[id changes]]
              (let [values-in-db   (get entity-db id)
                    originals-set? (-> values-in-db :group.config/default-work-type-gc some?)
                    is-new-value?  (fn [attr pred-fn]
                                     (and (contains? changes attr)
                                          (pred-fn (get changes attr))))
                    type?          (partial is-new-value? :group.config/default-work-type-gc)
                    target?        (partial is-new-value? :group.config/default-work-target-gc)
                    single-value?  (fn [pred-fn]
                                     (or (and (type? pred-fn)
                                              (not (target? pred-fn)))
                                         (and (not (type? pred-fn))
                                              (target? pred-fn))))]
                (not (or
                       ;; Setting only the work type or target when there is no original value
                       (and (not originals-set?)
                            (single-value? some?))
                       ;; Unsetting only the work type or target but not both
                       (single-value? nil?)))))
            id->changes)))


(defn selector
  "Allows the authority admin to select the default work type and target for the given category.
  The applicant is not allowed to change a default work type or target."
  [{:keys [tr ptc-id permit-type category-config selected-settings]}]
  (let [on-change-fn!     (partial update-changes! ptc-id category-config)
        category-id       (:db/id category-config)
        current-type-id   (get-current-value selected-settings category-config :group.config/default-work-type-gc true)
        current-target-id (get-current-value selected-settings category-config :group.config/default-work-target-gc true)
        prevented?        (get-current-value selected-settings category-config :group.config/default-change-prevented? false)
        work-types        (<sub [::gas/child-group-configs-sorted category-id])
        work-targets      (<sub [::gas/child-group-configs-sorted current-type-id])
        current-type      (p/find-first work-types {:db/id current-type-id})
        current-target    (p/find-first work-targets {:db/id current-target-id})
        lang              (<sub [:language])]
    [:div {:on-click #(.stopPropagation %)}
     [:div.mt-6.flex.flex-wrap
      [ui-select/select
       {:id           (str "default-work-type-" permit-type "-" category-id)
        :data-cy      "select-default-work-type"
        :label-text   (tr [:group.config/default-work-type])
        :values       work-types
        :val->str     #(i18n-model/get-text (:group.config/names %) lang)
        :select-text  (tr [:none])
        :allow-empty? true
        :on-change    #(cond-> [[:group.config/default-work-type-gc (:db/id %)]]
                         current-target-id
                         (conj [:group.config/default-work-target-gc nil])

                         (nil? %)
                         (conj [:group.config/default-change-prevented? nil])

                         :always
                         on-change-fn!)
        :value        current-type}]
      [ui-select/select
       {:id           (str "default-work-target-" permit-type "-" category-id)
        :data-cy      "select-default-work-target"
        :label-text   (tr [:group.config/default-work-target])
        :values       work-targets
        :disabled     (nil? current-type)
        :val->str     #(i18n-model/get-text (:group.config/names %) lang)
        :select-text  (tr [:none])
        :allow-empty? false
        :on-change    #(on-change-fn! [[:group.config/default-work-target-gc (:db/id %)]])
        :value        current-target}]]
     (cc/checkbox
       {:id         (str "prevent-default-" permit-type "-" category-id)
        :data-cy    "prevent-default-checkbox"
        :label-text (tr [:group.config/prevent-default-change])
        :disabled   (or (nil? current-type)
                        (nil? current-target))
        :checked    (boolean prevented?)
        :on-change  #(on-change-fn! [[:group.config/default-change-prevented? (when % true)]])})]))
